import dynamic from 'next/dynamic';
import React from 'react';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import useIsClient from '@/app/components/search/hooks/useIsClient.ts';
import { createFlashSalesConfig } from '@/app/common/components/Promotions/FlashSalesCounter/utils.ts';
import type { BadgeContext } from '../types';

const FlashSalesCounter = dynamic(() => import('@/app/common/components/Promotions/FlashSalesCounter'), {
  ssr: false,
});

const CardGalleryFlashSalesBadge = ({ dealCard }: BadgeContext) => {
  const { t } = useTranslation();
  const isClient = useIsClient();
  const flashSalesConfig = createFlashSalesConfig(dealCard, t);

  if (!isClient || !flashSalesConfig?.isActive) return null;

  return <FlashSalesCounter flashSalesConfig={flashSalesConfig} />;
};

export default CardGalleryFlashSalesBadge;
